import { z } from 'zod';
import { getBaseOasisValidationSchema } from '../../oasis';
// eslint-disable-next-line
export const sectionOSkipPatterns = ({ input, ctx, isSection, field }) => {
    const schema = getBaseOasisValidationSchema('e1', 'soc'); // args here doesn't have a purpose
    const payload = input;
    // O-skip pattern-5070 If M1041_IN_INFLNZ_SEASON=[1], then if M1046_INFLNZ_RECD_CRNT_SEASON is active it must not equal [^].
    if (payload?.m1041 === '1' && !payload.m1046) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5070 If M1041 = 1, then M1046 must NOT be empty.',
            path: ['m1046'],
        });
    }
    // O-skip pattern-5080 If M1041_IN_INFLNZ_SEASON=[0], then if M1046_INFLNZ_RECD_CRNT_SEASON is active it must equal [^].
    if (payload?.m1041 === '0' && payload.m1046) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5070 If M1041 = 0, then M1046 must be empty.',
            path: ['m1046'],
        });
    }
};
// O-skip pattern-5070 If M1041_IN_INFLNZ_SEASON=[1], then if M1046_INFLNZ_RECD_CRNT_SEASON is active it must not equal [^].
// O-skip pattern-5080 If M1041_IN_INFLNZ_SEASON=[0], then if M1046_INFLNZ_RECD_CRNT_SEASON is active it must equal [^].
